module.exports = __webpack_public_path__ + "static/media/deploy.dd97fbdc.mp3";